import { render } from "./GateDispatch.vue?vue&type=template&id=1feee683&scoped=true"
import script from "./GateDispatch.vue?vue&type=script&lang=js"
export * from "./GateDispatch.vue?vue&type=script&lang=js"

import "./GateDispatch.vue?vue&type=style&index=0&id=1feee683&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1feee683"]])

export default __exports__